var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./styles.scss";
import { useMemo } from "react";
import { useEventCollection } from "@react-components/modules/EventList/useEventCollection";
import { CollectionEntries, CollectionFilters, CollectionLoadMore, CollectionRoot, } from "@react-components/ui/Collection/Collection";
import { Select, Option } from "@react-components/ui/Forms/Select";
import { ContentCard } from "@react-components/ui/Cards/ContentCard/ContentCard";
var getMonths = function (locale) {
    var months = [];
    var d = new Date();
    for (var month = 0; month < 12; ++month) {
        d.setMonth(month);
        months.push({
            value: "".concat(month + 1).padStart(2, "0"),
            label: d.toLocaleString(locale, { month: "long" }),
        });
    }
    return months;
};
var getYears = function (startYear) {
    var years = Array.from(Array(new Date().getFullYear() - startYear), function (_, i) { return (i + startYear).toString(); });
    years.push(new Date().getFullYear().toString());
    return years.reverse();
};
var EventList = function (_a) {
    var pageTypeTags = _a.pageTypeTags, showFilters = _a.showFilters, dictionary = _a.dictionary, locale = _a.locale, pageSize = _a.pageSize, headline = _a.headline, content = _a.content;
    var years = useMemo(function () { return getYears(2010); }, []);
    var months = useMemo(function () { return getMonths(locale); }, []);
    var _b = useEventCollection(pageTypeTags, locale, pageSize), pageTypeCollection = _b.pageTypeCollection, isLastPage = _b.isLastPage, error = _b.error, setSize = _b.setSize, isValidating = _b.isValidating, setMonth = _b.setMonth, setYear = _b.setYear, month = _b.month, year = _b.year, filtersChanged = _b.filtersChanged;
    if (error) {
        console.log({ error: error });
        return null;
    }
    if ((pageTypeCollection === null || pageTypeCollection === void 0 ? void 0 : pageTypeCollection.flatMap(function (x) { return x.collection; }).length) === 0 &&
        !filtersChanged) {
        return null;
    }
    return (_jsxs(CollectionRoot, { children: [(headline || content) && (_jsxs("div", { className: "module-text module-text--no-pad", children: [headline && _jsx("h2", { className: "h2", children: headline }), content && (_jsx("div", { className: "richtext", dangerouslySetInnerHTML: {
                            __html: content,
                        } }))] })), showFilters && (_jsxs(CollectionFilters, { children: [_jsxs(Select, { label: dictionary.month, onChange: function (newValue) {
                            return newValue === "clear"
                                ? setMonth("")
                                : setMonth(newValue);
                        }, children: [_jsx(Option, { value: "clear", children: !month ? (dictionary.month) : (_jsx("span", { className: "text-bold", children: dictionary.clear })) }, "select-month-clear"), months.map(function (item) { return (_jsx(Option, { value: item.value, label: item.label, className: "select__option event-list__dropdown-months", children: item.label }, "select-month-".concat(item.value))); })] }), _jsxs(Select, { label: dictionary.year, onChange: function (newValue) {
                            return newValue === "clear"
                                ? setYear("")
                                : setYear(newValue);
                        }, children: [_jsx(Option, { value: "clear", children: !year ? (dictionary.year) : (_jsx("span", { className: "text-bold", children: dictionary.clear })) }, "select-month-clear"), years.map(function (item) { return (_jsx(Option, { value: "".concat(item), label: "".concat(item), children: item }, "select-year-".concat(item))); })] })] })), _jsx(CollectionEntries, { keyPrefix: "event-list", collection: pageTypeCollection === null || pageTypeCollection === void 0 ? void 0 : pageTypeCollection.flatMap(function (x) { return x.collection; }), renderEntry: function (props) { return (_jsx(ContentCard, __assign({}, props, { pageTypeName: props.trumpet || "­", width: [390, 510, 270, 245, 295, 345], height: [190, 195, 195, 195, 195, 195], useRatio: true }))); } }), !isLastPage && (_jsx(CollectionLoadMore, { disable: isValidating, onClick: function () { return setSize(function (size) { return size + 1; }); }, children: (dictionary === null || dictionary === void 0 ? void 0 : dictionary.loadMore) && (dictionary === null || dictionary === void 0 ? void 0 : dictionary.loadMore) }))] }));
};
export { EventList };
